import { useCallback, useRef, useState } from 'react';

export const useDeepgramTranscribeRecordedAudio = (
  apiKey,
  micStream,
  localeCode
) => {
  const recordedChunksRef = useRef([]);
  const [error, setError] = useState(null);
  const mediaRecorderRef = useRef(null);

  const start = useCallback(() => {
    mediaRecorderRef.current = new MediaRecorder(micStream);
    mediaRecorderRef.current.ondataavailable = (event) => {
      console.log('data available');
      if (event.data.size > 0) {
        recordedChunksRef.current.push(event.data);
      }
    };
    mediaRecorderRef.current.start(200);
  }, [micStream]);

  const send = useCallback(async () => {
    try {
      mediaRecorderRef.current.stop();
      const blob = new Blob(recordedChunksRef.current, {
        type: 'audio/webm',
      });
      const localeString = localeCode ? `&language=${localeCode}` : '';
      const response = await fetch(
        `https://api.deepgram.com/v1/listen?model=nova-2&smart_format=true${localeString}`,
        {
          body: blob,
          method: 'POST',
          headers: {
            Authorization: `Token ${apiKey}`,
            'Content-Type': 'deepgram/audio+video',
          },
        }
      );
      recordedChunksRef.current = [];
      return response;
    } catch (e) {
      setError(e.toString());
    }
  }, [apiKey, localeCode]);
  return { start, send, error };
};
